
import { useState } from "react";
import styled from "styled-components";

const Tooltip = ({ children, message }: { children: React.ReactNode, message: string | React.ReactNode }) => {

    const [isHovered, setIsHovered] = useState(false);


    return <TooltipContainer onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)}>
            {children}
            {isHovered && (
                <MessageContainer>
                    {message}
                </MessageContainer>
            )}
        </TooltipContainer>
}

export default Tooltip;

const TooltipContainer = styled.div`
cursor: pointer;
`;

const MessageContainer = styled.div`
    max-width: 300px;
    position: absolute;
    z-index: 10000;
    background-color: black;
    color: white;
    padding: 8px;
`